import React from "react";
import * as styles from "./base.scss";
import classnames from "classnames";
import getMenuIcon from "../../../Category/Commerce/Components/action-creators";
import MyMenigoIcon from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
const MenuColumn = ({ items, className, categoryIcons }) => (React.createElement("ul", { className: classnames(styles.menuItemsList, className) }, items &&
    items.primaryMenuItems.map((item, index) => (React.createElement("li", { key: "left" + index },
        React.createElement("div", { className: styles.primaryName },
            React.createElement("a", { href: item.url }, item.displayName)),
        item.children && (React.createElement("ul", null, item.children.map((childitem, childindex) => (React.createElement("li", { key: "child" + childindex },
            React.createElement("div", { className: styles.childrenName },
                React.createElement("a", { href: childitem.url },
                    !!getMenuIcon(childitem, categoryIcons) && (React.createElement(MyMenigoIcon, { name: getMenuIcon(childitem, categoryIcons) })),
                    childitem.displayName))))))))))));
export default MenuColumn;
